<script>
import Testimonial from "../Testimonial.vue";

export default {
  components: { Testimonial },
  name: "ChallengeOfferLeft",
  data: function() {
    return {
      testimonials: {
        kristin: {
          photo: "powerdrops/testimonial-kristin.png",
          name: "Kristín Sjofn",
          title: "Aromatherapist and educator, Aromatherapyskólinn.",
          quote: `Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.`
        },
        sylvia: {
          photo: "powerdrops/testimonial-sylvia.png",
          name: "Sylvia Provenski",
          title: "Nurse and Aromatherapy Student.",
          quote: `I'm just always amazed at how much I don't know! I don't profess to be an expert, but I've been hearing, reading, and seeing the same information over the last few years. But I have never seen some of the information that you present in the course.`
        },
        branko: {
          photo: "powerdrops/testimonial-branko.png",
          name: "Branko Čičić",
          title: "Maharishi Aromatherapy Consultant.",
          quote: `I would like to express my sincere, unreserved admiration for Melani as an Aromatherapy teacher! Her knowledge is profound, highly professional, practically useful, and applicable to all levels of skill and expertise. She teaches with ease the most complex topics, so they become simple to understand, easy to integrate into one’s former training and apply in practice – the rare skill of those who live the Aromatherapy with the fullness of their being. Her mind is brilliant, her passion infectious! A unique treasury of knowledge in Aromatherapy at its best.`
        },
      }
    };
  }
};
</script>
<template>
  <div id="pd-left-container">
    <div id="product-image">
      <img src="@/assets/smart-blending-program.png" width="100%">
    </div>
    <ul id="ul1">
        <li class="product-items">
          <span><strong>Unlock Expert Blending Skills with SMART Blending.</strong> <p>Congratulations on taking the next step in your aromatherapy journey! In just 5 weeks, you'll gain the expertise to:</p></span>
          <ul>
            <li><strong>Craft Child-Safe Blends</strong> in under 5 minutes using our educational materials and the intuitive Dropsmart App.</li>
            <li><strong>Identify Aromatic Notes</strong> with ease, thanks to vibrant chemistry piecharts that make learning a breeze.</li>
            <li><strong>Back Your Expertise</strong> with solid proof, courtesy of Dropsmart's extensive database of nearly 15,000 references.</li>
          </ul>
        </li>
        <li class="product-items">
          <span><strong>Why Trust Dropsmart?</strong></span>
          <ul>
            <li><strong>Credibility:</strong> With Dropsmart, your advice is supported by evidence-based guidelines, ensuring client safety and trust.</li>
            <li><strong>Professionalism:</strong> Demonstrate high standards and dedication to factual accuracy, enhancing your reputation.</li>
            <li><strong>Authority:</strong> Fast-track your path to becoming an Essential Oli Expert with reliable, accessible information.</li>
          </ul>
        </li>
        <li class="product-items">
          <span><strong>What's Included?</strong></span>
          <ul>
            <li><strong>Premium Content: </strong>Engaging emails, videos, and PDFs tailored by Dropsmart's Founder, Melani.</li>
            <li><strong>Practical Tools: </strong>Learn complex concepts made simple with Dropsmart's premium app features.</li>
            <li><strong>Holistic Insights: </strong>In-depth video lessons on essential oil safety, blending, notes and more for a full-spectrum service.</li>
          </ul>
        </li>
        <li class="product-items">
          <span><strong>Bonuses Just For You:</strong></span>
          <ul>
            <li><strong>Access to 3 Next Level Lessons: </strong>Dive into advanced safety techniques, chemistry connections, and note application lessons.</li>
            <li><strong>Dropsmart Premium: </strong>A monthly subscription to complement your learning and maximize your potential.</li>
            <li><strong>Live Q&A Sessions: </strong>Interact and get your questions answered, with recordings available for replay.</li>
          </ul>
        </li>
        <li class="product-items">
          <span><strong>Ready for Transformation?</strong></span>
          <p>
            Don't let doubts hold you back. You can always use the 30-day no-questions-asked money-back guarantee. Whether you're new to chemistry or seeking fresh insights, SMART Blending is designed for all levels of passion and commitment. With over 800 essential oils at your fingertips and a wealth of resources, it's time to elevate your expertise.
          </p>
        </li>
        <li class="product-items">
          <span><strong>Join the informed, confident aromatherapists from over 30 countries worldwide today. Say YES to SMART Blending!</strong></span>
          <p>
            Fill out the form on the right and start your transformation today.
          </p>
        </li>
    </ul>
    <div class="testimonials">
      <Testimonial :testimonial="testimonials.kristin" />
      <Testimonial :testimonial="testimonials.sylvia" />
      <Testimonial :testimonial="testimonials.branko" />
    </div>

    <b-card no-body class="overflow-hidden" style="font-size: 0.8em; border: none; margin-top: 3rem">
      <b-row no-gutters>
        <b-col md="3">
          <b-card-img :src="require('@/assets/aromaempress/Just-30-Days-Guarantee.jpg')"/>
        </b-col>
        <b-col md="9">
          <b-card-body title="30-Day Money-Back Guarantee">
            <b-card-text>
            Try it <strong>100% RISK-FREE with our 30-day-money-back-guarantee</strong>. If for some reason
            you aren't on your way to real success in the first 30 days, email us and we will take care of your refund!
            This means you get 30 days of test driving, on us!
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

* {
  font-family: $font-family;
}

#pd-left-container {
  font-size: 1.3rem;
  flex-basis: 100%;
  margin-top: -65px;
  color: #293847;
}

#product-image {
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.bonus {
   margin-left: 10px;
    display: inline;
}

#program-content {
  line-height: 1.77em;
  h4 {
    font-size: 1em;
    font-weight: 600;
    margin-bottom: 1em;
  }
  ul {
    margin-left: 1em;
    padding: 0;    
  }
}
.product-items {
  padding: 0px 0px 0px 0px;
  margin-left: -1.75em;
  margin-bottom: 20px;
  text-align: left;
  list-style: none;
}
</style>
